import { useContext } from 'react';

import { RealtimeContext } from '../context/RealtimeContext';

/**
 * Access to the app's single WebSocket (Rule 21).
 *
 *   const { status, send, subscribe, subscribeAll } = useRealtimeSocket();
 *   useEffect(() => subscribe('member:M-0001', (event) => { … }), [subscribe]);
 *
 * The connection itself lives in `<RealtimeProvider>` so every caller shares one
 * socket. Outside the provider this returns an inert stub rather than throwing —
 * a component rendered in a test or a public page should degrade to "no
 * realtime", never crash.
 */
const INERT = {
  status: 'disconnected',
  send: () => false,
  subscribe: () => () => {},
  subscribeAll: () => () => {},
};

export default function useRealtimeSocket() {
  return useContext(RealtimeContext) ?? INERT;
}
